'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/tickets/Flat.tsx
import { jsx } from "react/jsx-runtime";
var FlatTicketIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V9.25C22 9.58821 21.7736 9.88458 21.4473 9.97357C19.4342 10.5226 19.4342 13.4774 21.4473 14.0264C21.7736 14.1154 22 14.4118 22 14.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V14.75C2 14.4118 2.22637 14.1154 2.55266 14.0264C4.56578 13.4774 4.56578 10.5226 2.55266 9.97357C2.22637 9.88458 2 9.58821 2 9.25V6.75ZM4.75 5.5C4.05964 5.5 3.5 6.05964 3.5 6.75V8.72312C6.25 9.95184 6.25 14.0482 3.5 15.2769V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V15.2769C17.75 14.0482 17.75 9.95184 20.5 8.72312V6.75C20.5 6.05964 19.9404 5.5 19.25 5.5H4.75ZM15.25 7C15.6642 7 16 7.33579 16 7.75V8.25C16 8.66421 15.6642 9 15.25 9C14.8358 9 14.5 8.66421 14.5 8.25V7.75C14.5 7.33579 14.8358 7 15.25 7ZM15.25 11C15.6642 11 16 11.3358 16 11.75V12.25C16 12.6642 15.6642 13 15.25 13C14.8358 13 14.5 12.6642 14.5 12.25V11.75C14.5 11.3358 14.8358 11 15.25 11ZM15.25 15C15.6642 15 16 15.3358 16 15.75V16.25C16 16.6642 15.6642 17 15.25 17C14.8358 17 14.5 16.6642 14.5 16.25V15.75C14.5 15.3358 14.8358 15 15.25 15Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/tickets/TicketIcon.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var TicketIcon = ({ className = "", double = true }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "21",
      viewBox: double ? "0 0 24 21" : "0 0 18 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        double && /* @__PURE__ */ jsx2(
          "path",
          {
            opacity: "0.3",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1176 10.928C10.7082 10.5185 9.95358 10.5185 9.54411 10.928L7.6527 12.8194C7.29054 13.1816 7.29054 13.7688 7.6527 14.131L8.05098 14.5292C8.4072 14.8855 9.04912 14.9007 9.60245 14.8521C10.1611 14.8031 10.7368 14.9924 11.1644 15.42C11.6868 15.9424 11.8535 16.6859 11.6644 17.3494C11.5668 17.6918 11.5924 18.0707 11.8627 18.341L12.4535 18.9318C12.8157 19.294 13.4029 19.294 13.765 18.9318L15.8968 16.8C16.2134 16.4834 16.2134 16.0234 15.8968 15.7068L15.332 15.1419C15.0251 14.835 15.0251 14.3375 15.332 14.0306C15.6388 13.7237 16.1364 13.7237 16.4433 14.0306L16.768 14.3553C17.1775 14.7648 17.932 14.7648 18.3415 14.3553L23.0112 9.68556C23.3733 9.32339 23.3733 8.7362 23.0112 8.37403L22.6128 7.97567C22.2566 7.61942 21.6146 7.60421 21.0613 7.65278C20.5026 7.70182 19.9269 7.51253 19.4993 7.08493C18.9769 6.56247 18.8102 5.81895 18.9993 5.15545C19.0969 4.81305 19.0713 4.4341 18.801 4.16377L18.2104 3.57316C17.8482 3.21099 17.261 3.21099 16.8988 3.57316L11.9888 8.48328C11.6722 8.79989 11.6722 9.25984 11.9888 9.57645L12.5535 10.1412C12.8604 10.448 12.8604 10.9456 12.5535 11.2525C12.2466 11.5594 11.749 11.5594 11.4421 11.2525L11.1176 10.928ZM13.1092 12.9196C12.8023 12.6127 12.8023 12.1151 13.1092 11.8082C13.4161 11.5013 13.9136 11.5013 14.2205 11.8082L14.7762 12.3639C15.0831 12.6708 15.0831 13.1683 14.7762 13.4752C14.4693 13.7821 13.9717 13.7821 13.6648 13.4752L13.1092 12.9196Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.6629 9.30772L0.984736 11.9859C0.622568 12.3481 0.622568 12.9353 0.984736 13.2975L2.0237 14.3364C2.78649 13.8311 3.82433 13.9144 4.49639 14.5865C5.16845 15.2586 5.25181 16.2964 4.74645 17.0592L5.78554 18.0983C6.14771 18.4605 6.7349 18.4605 7.09707 18.0983L9.77545 15.4199L8.66399 14.3084C8.3571 14.0015 8.3571 13.504 8.66399 13.1971C8.97087 12.8902 9.46844 12.8902 9.77532 13.1971L10.8868 14.3086L16.3432 8.85207C16.7054 8.4899 16.7054 7.9027 16.3432 7.54053L15.3041 6.50144C14.5413 7.00686 13.5034 6.92353 12.8314 6.25143C12.1593 5.57934 12.0759 4.54144 12.5814 3.77863L11.5424 2.73967C11.1802 2.37749 10.593 2.37749 10.2309 2.73967L4.77424 8.19637L5.88551 9.30766C6.1924 9.61455 6.1924 10.1121 5.88551 10.419C5.57863 10.7259 5.08107 10.7259 4.77418 10.419L3.6629 9.30772ZM6.44121 12.0861C6.13432 11.7792 6.13432 11.2816 6.44121 10.9747C6.74809 10.6678 7.24566 10.6678 7.55254 10.9747L8.10821 11.5304C8.41509 11.8373 8.41509 12.3348 8.10821 12.6417C7.80132 12.9486 7.30376 12.9486 6.99687 12.6417L6.44121 12.0861Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};

// src/tickets/TicketShield.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var TicketShieldIcon = (props) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx3(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.4345 15.2723L18.138 13.9993L21.8415 15.2723V18.1018C21.8415 19.2568 21.3687 20.0891 20.6842 20.7373C20.0371 21.3498 19.1894 21.8069 18.398 22.2337L18.138 22.3739L17.878 22.2337C17.0865 21.8069 16.2389 21.3498 15.5918 20.7373C14.9073 20.0891 14.4345 19.2568 14.4345 18.1018V15.2723ZM19.7487 17.2121L19.1667 16.6302L17.7265 18.0704L17.1092 17.4532L16.5273 18.0351L17.7265 19.2343L19.7487 17.2121Z",
            fill: "#22C55E"
          }
        ),
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M22 9.92676L21.3711 10.1787C20.389 10.5717 19.9881 11.5404 20.167 12.4043C19.5315 12.158 18.8439 12.0176 18.125 12.0029C18.1241 10.6992 18.7491 9.39515 20 8.63477V6H4V8.63477C6.4999 10.1544 6.4999 13.8456 4 15.3652V18H12C12 18.7014 12.1216 19.3743 12.3428 20H2V14.0732L2.62891 13.8213C4.29031 13.1564 4.29031 10.8436 2.62891 10.1787L2 9.92676V4H22V9.92676ZM16 12.3418C15.5258 12.5094 15.079 12.7348 14.668 13.0098H14V11H16V12.3418ZM16 9.00977H14V7H16V9.00977Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/tickets/TicketWarning.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var TicketWarningIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs3(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M3.7972 46.3752C2.25715 47.9152 2.26179 50.4263 3.80715 51.9717L10.2898 58.4543C12.0423 56.9446 14.4334 56.365 16.6541 56.9408C19.7964 57.7693 22.0412 59.8942 22.818 62.774C23.4636 65.1614 22.9523 67.7059 21.4858 69.6504L28.0283 76.1929C29.5737 77.7382 32.0848 77.7429 33.6248 76.2028L67.0635 42.7642L37.2358 12.9365L3.7972 46.3752ZM46.0559 33.9524C51.264 39.1605 51.2602 47.6382 46.0467 52.8517C40.8341 58.0643 32.3562 58.0682 27.1482 52.8601C21.9348 47.6467 21.9347 39.1651 27.1474 33.9524C32.3608 28.739 40.8424 28.7389 46.0559 33.9524Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M36.6039 54.5741C42.7579 54.5741 47.764 49.5627 47.764 43.4022C47.764 37.2417 42.7579 32.2292 36.6039 32.2292C30.4434 32.2292 25.4309 37.2417 25.4309 43.4022C25.4309 49.5627 30.4434 54.5741 36.6039 54.5741ZM35.4987 38.7277C35.4987 38.1205 35.9901 37.6291 36.5973 37.6291C37.2045 37.6291 37.6959 38.1205 37.6959 38.7277V43.4966C37.6959 44.1038 37.2045 44.5952 36.5973 44.5952C35.9901 44.5952 35.4987 44.1038 35.4987 43.4966V38.7277ZM35.4987 47.5758C35.4987 46.9686 35.9901 46.4772 36.5973 46.4772C37.2045 46.4772 37.6959 46.9686 37.6959 47.5758V48.0769C37.6959 48.6841 37.2045 49.1755 36.5973 49.1755C35.9901 49.1755 35.4987 48.6841 35.4987 48.0769V47.5758Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M76.193 28.0282L69.6519 21.4871C66.5377 23.8412 62.073 23.6007 59.2358 20.7634C56.3985 17.9262 56.158 13.4616 58.512 10.3472L51.9717 3.8069C50.4263 2.26154 47.9152 2.2569 46.3744 3.79773L38.7895 11.3827L68.617 41.2102L76.2019 33.6253C77.7428 32.0847 77.7383 29.5735 76.193 28.0282Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};

// src/tickets/WbkProtectedTicket.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var WbkProtectedTicket = (props) => {
  return /* @__PURE__ */ jsxs4(
    "svg",
    __spreadProps(__spreadValues({
      width: "204",
      height: "140",
      viewBox: "0 0 204 140",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx5("g", { filter: "url(#filter0_d_17356_24212)", children: /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M192.807 16.1763C197.565 15.0486 201.308 18.0968 201.166 22.985L200.449 47.609C200.433 48.1427 199.926 48.6482 199.407 48.7713C197.166 49.3025 195.294 51.5998 195.227 53.9022C195.16 56.2047 196.923 57.6407 199.164 57.1096C199.684 56.9864 200.168 57.2581 200.152 57.7917L199.466 81.3714C199.323 86.2594 195.349 91.1365 190.591 92.2641L59.6865 123.286C54.9282 124.414 51.1862 121.365 51.3283 116.477L51.9799 94.0994C51.9981 93.475 52.5838 92.8819 53.1916 92.7379C55.7132 92.1402 57.8119 89.7892 57.8789 87.4867C57.9459 85.1842 55.9559 83.8022 53.4344 84.3996C52.8266 84.5437 52.2675 84.221 52.2857 83.5966L53.0284 58.091C53.1708 53.2029 57.1436 48.3262 61.9019 47.1984L192.807 16.1763Z",
            fill: "#27272A"
          }
        ) }),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M96.4888 62.3345C96.5647 62.3169 96.639 62.3199 96.7037 62.3427C96.7683 62.3654 96.822 62.4069 96.8587 62.4639L98.9215 65.7742L100.758 68.7213C100.794 68.7785 100.848 68.8211 100.912 68.8438C100.977 68.8665 101.051 68.869 101.127 68.851C101.203 68.833 101.278 68.7951 101.344 68.7413C101.411 68.6875 101.467 68.6191 101.508 68.5436L104.805 62.2792C104.845 62.2039 104.902 62.1362 104.969 62.0824C105.035 62.0286 105.111 61.9905 105.187 61.9725C105.263 61.9546 105.336 61.9573 105.401 61.98C105.465 62.0026 105.519 62.0443 105.555 62.1015L108.534 66.8786C108.57 66.936 108.623 66.9784 108.687 67.0013C108.751 67.0241 108.825 67.0266 108.901 67.0087C108.977 66.9908 109.052 66.9529 109.118 66.899C109.185 66.8452 109.241 66.7769 109.281 66.7016L111.316 62.8368L113.602 58.4961C113.642 58.4205 113.698 58.3523 113.765 58.2984C113.833 58.2443 113.909 58.2061 113.985 58.1882L119.358 56.9148C119.415 56.9009 119.472 56.8983 119.524 56.9076C119.576 56.9169 119.622 56.938 119.662 56.9689C119.701 57 119.732 57.0409 119.752 57.0889C119.773 57.1371 119.782 57.1922 119.781 57.2499L118.978 84.7126C118.977 84.7702 118.963 84.83 118.94 84.8884C118.917 84.9467 118.883 85.003 118.842 85.0532C118.8 85.1035 118.751 85.1471 118.698 85.1814C118.644 85.2156 118.588 85.2407 118.531 85.2538L107.467 87.8759L104.915 83.7867C104.879 83.7293 104.826 83.6868 104.762 83.664C104.698 83.6412 104.624 83.6386 104.548 83.6566C104.473 83.6745 104.398 83.7123 104.332 83.766C104.265 83.8199 104.208 83.8883 104.168 83.9637L101.345 89.3266L90.2805 91.9487C90.1661 91.9758 90.0578 91.9551 89.9792 91.8922C89.9008 91.8292 89.8585 91.7288 89.8619 91.6127L90.6615 64.1507C90.6649 64.0345 90.7136 63.9117 90.7969 63.8103C90.8802 63.7092 90.9914 63.6373 91.1057 63.6102L96.4888 62.3345ZM146.569 50.4664C146.644 50.4492 146.718 50.4514 146.783 50.4739L151.676 52.2177C151.741 52.2407 151.794 52.284 151.83 52.3421C151.866 52.4001 151.883 52.4719 151.88 52.5492L151.656 60.2461L146.921 64.0786C146.855 64.133 146.8 64.2021 146.76 64.2778C146.72 64.3534 146.698 64.4334 146.696 64.5102C146.693 64.5872 146.711 64.6583 146.747 64.7161C146.783 64.7738 146.835 64.8167 146.899 64.84L151.475 66.4613L151.251 74.1611C151.25 74.238 151.228 74.3186 151.188 74.3943C151.148 74.4698 151.091 74.5376 151.024 74.591L145.961 78.6943C145.895 78.749 145.819 78.7877 145.743 78.805L122.468 84.3208C122.411 84.3346 122.356 84.3361 122.304 84.3268C122.252 84.3175 122.204 84.2968 122.165 84.2657C122.126 84.2346 122.095 84.1935 122.075 84.1455C122.055 84.0974 122.045 84.0431 122.047 83.9855L122.846 56.5235C122.848 56.4657 122.861 56.4052 122.884 56.3467C122.908 56.2883 122.941 56.2321 122.983 56.1819C123.024 56.1316 123.074 56.088 123.127 56.0536C123.18 56.0195 123.237 55.9953 123.293 55.9823L146.569 50.4664ZM166.294 45.7919C166.369 45.774 166.443 45.7764 166.508 45.7993C166.572 45.8222 166.625 45.8646 166.661 45.922L169.093 49.8204C169.129 49.8778 169.182 49.9203 169.246 49.9431C169.311 49.9658 169.384 49.9686 169.459 49.9508C169.535 49.9328 169.61 49.8949 169.677 49.8411C169.744 49.7872 169.799 49.719 169.839 49.6436L172.534 44.5301C172.574 44.4546 172.63 44.3866 172.697 44.3327C172.763 44.2787 172.838 44.2407 172.914 44.223L183.732 41.6594C183.846 41.6323 183.954 41.6522 184.033 41.715C184.111 41.7779 184.154 41.8793 184.15 41.9955L183.887 51.0375L179.826 54.3256L176.42 57.0841C176.354 57.1384 176.297 57.2069 176.258 57.2826C176.218 57.3582 176.196 57.4388 176.194 57.5157C176.192 57.5926 176.209 57.664 176.245 57.7218C176.281 57.7795 176.334 57.8222 176.398 57.8455L179.689 59.014L183.614 60.4095L183.351 69.4574C183.347 69.5736 183.299 69.6955 183.215 69.7968C183.132 69.8981 183.021 69.9709 182.906 69.998L172.089 72.5616C172.013 72.5797 171.939 72.577 171.875 72.5541C171.81 72.5312 171.758 72.4882 171.722 72.4304L170.389 70.2907L169.289 68.5292C169.253 68.4727 169.199 68.4319 169.135 68.4096C169.071 68.3873 168.997 68.3841 168.922 68.4019C168.847 68.4198 168.772 68.4581 168.706 68.5114C168.64 68.5645 168.584 68.6315 168.543 68.7059L165.848 73.8223C165.809 73.8978 165.753 73.9668 165.686 74.0208C165.619 74.0747 165.544 74.1125 165.469 74.1305L154.651 76.694C154.54 76.7204 154.435 76.7025 154.357 76.6445C154.279 76.5862 154.234 76.4913 154.232 76.3804L155.033 48.8735C155.041 48.7599 155.092 48.6418 155.174 48.5453C155.257 48.4489 155.365 48.3809 155.476 48.3555L166.294 45.7919Z",
            fill: "#FF2C79"
          }
        ),
        /* @__PURE__ */ jsx5(
          "line",
          {
            y1: "-0.521369",
            x2: "64.6498",
            y2: "-0.521369",
            transform: "matrix(-0.0291051 0.999576 -0.97305 0.230596 81.5442 47.719)",
            stroke: "white",
            strokeOpacity: "0.3",
            strokeWidth: "1.04274",
            strokeDasharray: "3.13 3.13"
          }
        ),
        /* @__PURE__ */ jsx5("foreignObject", { x: "22.3153", y: "22.5288", width: "73.125", height: "83.42", children: /* @__PURE__ */ jsx5(
          "div",
          {
            style: {
              backdropFilter: "blur(5.51px)",
              clipPath: "url(#bgblur_0_17356_24212_clip_path)",
              height: "100%",
              width: "100%"
            }
          }
        ) }),
        /* @__PURE__ */ jsx5("g", { filter: "url(#filter1_d_17356_24212)", "data-figma-bg-blur-radius": "11.0147", children: /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M58.4192 33.5435L83.9386 42.2052L84.4169 62.947C84.6117 71.4134 81.5215 77.6002 76.9535 82.4751C72.6359 87.0828 66.9217 90.5871 61.5862 93.8588C61.4408 93.9479 61.2957 94.0373 61.1509 94.1261L59.8337 94.9342L58.4806 94.1974C58.3318 94.1163 58.1824 94.0343 58.033 93.9528C52.5534 90.9677 46.684 87.7711 42.1596 83.3977C37.3728 78.7708 34.0024 72.7544 33.8075 64.2878L33.33 43.5467L58.4192 33.5435Z",
            fill: "url(#paint0_linear_17356_24212)"
          }
        ) }),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M61.2021 67.9172H56.0295V60.8805L61.2021 56.6586V53.8439H56.0295V56.6586H50.8569V48.2146H66.3747V59.4732L61.2021 63.6952V67.9172Z",
            fill: "#E4E4E7"
          }
        ),
        /* @__PURE__ */ jsx5("path", { d: "M61.2021 76.3893H56.0295V70.7318H61.2021V76.3893Z", fill: "#E4E4E7" }),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M27.8641 60.5789L0.997472 60.512",
            stroke: "#B3E100",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M32.4109 31.3755L16.0816 18.9412",
            stroke: "#B3E100",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx5(
          "path",
          {
            d: "M17.2856 102.801L33.2639 89.8525",
            stroke: "#B3E100",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsxs4("defs", { children: [
          /* @__PURE__ */ jsxs4(
            "filter",
            {
              id: "filter0_d_17356_24212",
              x: "51.3244",
              y: "15.9419",
              width: "151.931",
              height: "110.707",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsx5("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx5(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ jsx5("feOffset", { dx: "2.08548", dy: "3.12821" }),
                /* @__PURE__ */ jsx5("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx5("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" }),
                /* @__PURE__ */ jsx5("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_17356_24212" }),
                /* @__PURE__ */ jsx5(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_17356_24212",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs4(
            "filter",
            {
              id: "filter1_d_17356_24212",
              x: "22.3153",
              y: "22.5288",
              width: "73.125",
              height: "83.42",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsx5("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx5(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ jsx5("feOffset", { dx: "3.85478", dy: "2.44771" }),
                /* @__PURE__ */ jsx5("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx5("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0" }),
                /* @__PURE__ */ jsx5("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_17356_24212" }),
                /* @__PURE__ */ jsx5(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_17356_24212",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx5("clipPath", { id: "bgblur_0_17356_24212_clip_path", transform: "translate(-22.3153 -22.5288)", children: /* @__PURE__ */ jsx5("path", { d: "M58.4192 33.5435L83.9386 42.2052L84.4169 62.947C84.6117 71.4134 81.5215 77.6002 76.9535 82.4751C72.6359 87.0828 66.9217 90.5871 61.5862 93.8588C61.4408 93.9479 61.2957 94.0373 61.1509 94.1261L59.8337 94.9342L58.4806 94.1974C58.3318 94.1163 58.1824 94.0343 58.033 93.9528C52.5534 90.9677 46.684 87.7711 42.1596 83.3977C37.3728 78.7708 34.0024 72.7544 33.8075 64.2878L33.33 43.5467L58.4192 33.5435Z" }) }),
          /* @__PURE__ */ jsxs4(
            "linearGradient",
            {
              id: "paint0_linear_17356_24212",
              x1: "71.4674",
              y1: "65.472",
              x2: "118.682",
              y2: "102.278",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx5("stop", { stopColor: "#3F3F46" }),
                /* @__PURE__ */ jsx5("stop", { offset: "1", stopColor: "#FF2C79" })
              ]
            }
          )
        ] })
      ]
    })
  );
};

// src/tickets/WbkTicketIcon.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var WbkTicketIcon = (props) => {
  return /* @__PURE__ */ jsx6(
    "svg",
    __spreadProps(__spreadValues({
      width: "30",
      height: "25",
      viewBox: "0 0 30 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsxs5("g", { clipPath: "url(#clip0_10516_35740)", children: [
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M0 2.54688C0 1.44231 0.895431 0.546875 2 0.546875H4V8.54688H0V2.54688Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M0 2.54688C0 1.44231 0.895431 0.546875 2 0.546875H4V8.54688H0V2.54688Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M4 8.54688V16.5469H0C2.20914 16.5469 4 14.756 4 12.5469C4 10.3377 2.20914 8.54688 0 8.54688H4Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M4 8.54688V16.5469H0C2.20914 16.5469 4 14.756 4 12.5469C4 10.3377 2.20914 8.54688 0 8.54688H4Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M0 22.5469C0 23.6514 0.895431 24.5469 2 24.5469H4V16.5469H0V22.5469Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M0 22.5469C0 23.6514 0.895431 24.5469 2 24.5469H4V16.5469H0V22.5469Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6("rect", { width: "22", height: "24", transform: "translate(4 0.546875)", fill: "currentColor" }),
        /* @__PURE__ */ jsx6("rect", { width: "22", height: "24", transform: "translate(4 0.546875)", fill: "currentColor" }),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M30 2.54688C30 1.44231 29.1046 0.546875 28 0.546875H26V8.54688H30V2.54688Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M30 2.54688C30 1.44231 29.1046 0.546875 28 0.546875H26V8.54688H30V2.54688Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M26 8.54688V16.5469H30C27.7909 16.5469 26 14.756 26 12.5469C26 10.3377 27.7909 8.54688 30 8.54688H26Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M26 8.54688V16.5469H30C27.7909 16.5469 26 14.756 26 12.5469C26 10.3377 27.7909 8.54688 30 8.54688H26Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M30 22.5469C30 23.6514 29.1046 24.5469 28 24.5469H26V16.5469H30V22.5469Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M30 22.5469C30 23.6514 29.1046 24.5469 28 24.5469H26V16.5469H30V22.5469Z",
            fill: "currentColor"
          }
        )
      ] })
    })
  );
};

export {
  FlatTicketIcon,
  TicketIcon,
  TicketShieldIcon,
  TicketWarningIcon,
  WbkProtectedTicket,
  WbkTicketIcon
};
//# sourceMappingURL=chunk-P7COP3CJ.mjs.map